import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

const createOrderTracking = async (data: any): Promise<any> => {
  const result = await axios.post(`orders/${data.orderId}/trackings`, data)
  return result
}

export function useCreateOrderTracking() {
  const queryClient = useQueryClient()

  return useMutation(createOrderTracking, {
    onSuccess: () => {
      queryClient.invalidateQueries('ordersTrackings')
      queryClient.invalidateQueries('orderTrackings')
      queryClient.invalidateQueries('itemAttachments')

      toast.success('Acompanhamento criado com sucesso!', {
        toastId: 'ordersTrackings'
      })
    },
    onError: (error: unknown) => {
      console.error(error)

      toast.error('Não foi possível criar o acompanhamento!', {
        toastId: 'ordersTrackings'
      })
    }
  })
}
